import React from 'react';
import styled from 'styled-components';

import CloudIcon from '../resources/icons/cloud-icon.svg';
import BrokenClouds from '../resources/icons/broken-clouds-day-icon.svg';
import ClearSky from '../resources/icons/clear-sky-day-icon.svg';
import FewClouds from '../resources/icons/few-clouds-day-icon.svg';
import Mist from '../resources/icons/mist-day-icon.svg';
import Rain from '../resources/icons/rain-day-icon.svg';
import ScatteredClouds from '../resources/icons/scattered-clouds-day-icon.svg';
import ShowerRain from '../resources/icons/shower-rain-day-icon.svg';
import Snow from '../resources/icons/snow-day-icon.svg';
import Thunderstorm from '../resources/icons/thunderstorm-day-icon.svg';

import BrokenCloudsNight from '../resources/icons/broken-clouds-night-icon.svg';
import ClearSkyNight from '../resources/icons/clear-sky-night-icon.svg';
import FewCloudsNight from '../resources/icons/few-clouds-night-icon.svg';
import MistNight from '../resources/icons/mist-night-icon.svg';
import RainNight from '../resources/icons/rain-night-icon.svg';
import ScatteredCloudsNight from '../resources/icons/scattered-clouds-night-icon.svg';
import ShowerRainNight from '../resources/icons/shower-rain-night-icon.svg';
import SnowNight from '../resources/icons/snow-night-icon.svg';
import ThunderstormNight from '../resources/icons/thunderstorm-night-icon.svg';

const IconTranslate = {
  'broken_clouds': BrokenClouds,
  'clear_sky': ClearSky,
  'few_clouds': FewClouds,
  'mist': Mist,
  'rain': Rain,
  'scattered_clouds': ScatteredClouds,
  'shower_rain': ShowerRain,
  'snow': Snow,
  'thunderstorm': Thunderstorm,
}

const IconTranslateNight = {
  'broken_clouds': BrokenCloudsNight,
  'clear_sky': ClearSkyNight,
  'few_clouds': FewCloudsNight,
  'mist': MistNight,
  'rain': RainNight,
  'scattered_clouds': ScatteredCloudsNight,
  'shower_rain': ShowerRainNight,
  'snow': SnowNight,
  'thunderstorm': ThunderstormNight,
}

const Image = styled.img`
  max-width: 100%;
  width: 100%;
  height: auto;
`;

const Icon: React.FC<{name: string, isDaytime?: boolean}> = ({name, isDaytime = true}) => {
  return (
    <Image src={isDaytime ? IconTranslate[name] : IconTranslateNight[name] ?? CloudIcon}/>
  )
}

export default Icon;
